import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PanelFrame from "../../ui/PanelFrame";
import GuildMarker from "../../tools/guildMarker";
import { getTopGuilds } from "../../../store/reducers/reducerWeb";
import rank1 from "../../../assets/imgs/ui/guild-ranks/rank-1.png";
import rank2 from "../../../assets/imgs/ui/guild-ranks/rank-2.png";
import rank3 from "../../../assets/imgs/ui/guild-ranks/rank-3.png";
import { useLang } from "../../../i18n/LangContext";
import "./GuildsAll.scss";

const RANK_MEDALS = [rank1, rank2, rank3];

const GuildsAll = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useLang();
  const guildsState = useSelector((s) => s.reducerWeb?.top5Guild);
  const rows = Array.isArray(guildsState?.data) ? guildsState.data : [];

  useEffect(() => {
    dispatch(getTopGuilds());
  }, [dispatch]);

  return (
    <div className="mu-guilds-page">
      <PanelFrame title="Top Guilds" className="mu-guilds-page__frame">
        <div className="mu-guilds-page__toolbar">
          <Link className="mu-guilds-page__back" to="/">
            {t("back_to_home")}
          </Link>
        </div>

        <div className="mu-guilds-page__podium">
          {[0, 1, 2].map((i) => {
            const guild = rows[i];
            if (!guild) {
              return (
                <div
                  key={`empty-${i}`}
                  className={`mu-guilds-page__podium-slot mu-guilds-page__podium-slot--${
                    i + 1
                  } is-empty`}
                >
                  <img src={RANK_MEDALS[i]} alt={`Rank ${i + 1}`} />
                  <strong>—</strong>
                  <span>Score: —</span>
                </div>
              );
            }
            return (
              <button
                type="button"
                key={guild.G_Name || i}
                className={`mu-guilds-page__podium-slot mu-guilds-page__podium-slot--${
                  i + 1
                }`}
                onClick={() => navigate(`/guild/${guild.G_Name}`)}
              >
                <img src={RANK_MEDALS[i]} alt={`Rank ${i + 1}`} />
                <GuildMarker mark={guild.G_Mark} size={36} />
                <strong>{guild.G_Name}</strong>
                <span>Score: {guild.Score ?? 0}</span>
              </button>
            );
          })}
        </div>

        <div className="mu-guilds-page__table-wrap">
          <table className="mu-guilds-page__table">
            <thead>
              <tr>
                <th>#</th>
                <th>{t("col_guild")}</th>
                <th>{t("col_master")}</th>
                <th>{t("col_members")}</th>
                <th>{t("col_score")}</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={5}>No guilds found yet.</td>
                </tr>
              ) : (
                rows.map((guild, i) => (
                  <tr key={guild.G_Name || i}>
                    <td>{i + 1}</td>
                    <td>
                      <button
                        type="button"
                        className="mu-guilds-page__guild-btn"
                        onClick={() => navigate(`/guild/${guild.G_Name}`)}
                      >
                        <GuildMarker mark={guild.G_Mark} size={22} />
                        <span>{guild.G_Name}</span>
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="mu-guilds-page__link-btn"
                        onClick={() => navigate(`/player/${guild.G_Master}`)}
                      >
                        {guild.G_Master}
                      </button>
                    </td>
                    <td>{guild.Members ?? "—"}</td>
                    <td>{guild.Score ?? 0}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </PanelFrame>
    </div>
  );
};

export default GuildsAll;
